import AppRouter from 'common/AppRouter';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SidebarFreeBadge } from '@linearb/linui-common';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { isPostOnboardingWithoutReposSelector } from 'state/selectors/flows';

const Logo = ({ sidebarExpanded, onClick }) => {
  const location = useLocation();
  const { topbarHeight } = useSidebarState();
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const isPostOnboardingWithoutRepos = useSelector(
    isPostOnboardingWithoutReposSelector
  );
  const viewPath = location.pathname.split('/')[1];
  const isClickable = viewPath !== 'overdue' && !isPostOnboardingWithoutRepos;

  let constructedLogo = (
    <Flex
      direction='column'
      height={topbarHeight}
      items='center'
      justify='center'
    >
      <Icon
        name='Logo'
        color='darkBlue'
        size={sidebarExpanded ? 'large' : 'medium'}
        style={{
          transition: '0.1s'
        }}
      />
      {isTeamLicense && <SidebarFreeBadge />}
    </Flex>
  );

  if (isClickable) {
    constructedLogo = (
      <Link
        to={AppRouter.ROOT.path}
        style={{ width: '100%', textDecoration: 'none' }}
        onClick={() => onClick()}
      >
        {constructedLogo}
      </Link>
    );
  }
  return constructedLogo;
};

export default Logo;
